<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mb-0 p-0">
            <CCol sm="12" lg="12">
              <img
                src="../assets/img/bgFaq.jpg"
                style="max-width: 100%"
                class="text-center"
              />
            </CCol>
            <div class="text-center text-title text-bold">
              <h2 class="display-5">Frequently Asked Question</h2>
              <h6 class="text-muted m-3 display-6">
                We're here to help you with anything and <br />everything on
                Pickiddo
              </h6>
            </div>

            <div class="m-2">
              <div
              style="text-align: left;"
                v-for="item in faqs"
                :key="item.Id"
                :class="{ activeclass: item.isActive }"
              >
                <CCard class="p-4 mt-3">
                  <CRow style="text-align: left;">
                    <CCol  style="text-align: left;" sm="12" lg="12" @click="toggle(item)">
                      <div style="text-align: left" class="item-text">
                        <div class="btn-link display-7">
                          {{ item.Number }} . {{ item.Question }}</div
                        >
                      </div>
                    </CCol>

                    <CCol sm="12" lg="12">
                      <div
                        v-show="item.isActive"
                        class="item-desc ml-3 mb-2 display-8"
                      >
                        {{ item.Answer }}
                      </div>
                    </CCol>
                  </CRow>
                </CCard>
              </div>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>



<script>
import Vue from "vue";

export default {
  name: "Collapses",
  data() {
    return {
      faqs: [],
      answerFaq: {},
    };
  },
  async mounted() {
    this.GetQuestion();
    await this.GetAnswerFaq();
  },
  methods: {
    async GetQuestion() {
      this.$API
        .get(this.$Faq, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.faqs = response.data;
          }
        });
    },
    OpenUpdate(item) {
      this.Id = item.Id;
      this.updateElement = true;
      this.GetAnswerFaq(this.Id);
    },
    async GetAnswerFaq(Id) {
      this.$API
        .get(this.$AnswerFaqById + "?id=" + this.Id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.answerFaq = response.data;
          }
        });
    },
    toggle: function (item) {
      item.isActive = !item.isActive;
    },
  },
};
</script>